<template lang="pug">
  .charges.component
    table
      tr
        th Date
        th Amount
        th Paid With
      tr( v-for='charge in charges' )
        td {{ new Date( charge.created * 100 ).toLocaleDateString() }}
        td ${{ ( charge.amount / 1000 ).toFixed(2) }}
        td {{ charge.payment_method_details.card.brand }} {{ charge.payment_method_details.card.last4  }}
</template>

<script>
  import { fc } from '@/main'

  export default {
    props: {
      user: { type: Object, required: true },
      account: { type: Object, required: true }
    },

    data() {
      return {
        charges: []
      }
    },

    mounted() {
      fc.httpsCallable( 'charges' )({ source: this.account.stripe_id }).then( r => this.charges = r.data )
    }
  }
</script>

<style lang="stylus" scoped>
  .charges
    //
  
    table
      margin-top 32px
      width 100%
      th, td
        text-align center
        padding 8px 12px
        &:first-child
          text-align left
        &:last-child
          text-align right
      th
        font-weight bold
</style>